
import { useEffect, useState } from 'react';

const FounderStory = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 检查是否为手机设备
    const isMobile = window.innerWidth < 1024;
    
    if (isMobile) {
      // 手机版直接显示
      setIsVisible(true);
    } else {
      // 桌面版保持原有的滚动触发逻辑
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        },
        { threshold: 0.3 }
      );

      const element = document.getElementById('founder-story');
      if (element) {
        observer.observe(element);
      }

      return () => {
        if (element) {
          observer.unobserve(element);
        }
      };
    }
  }, []);

  return (
    <section 
      id="founder-story" 
      className="py-20 lg:py-40 relative overflow-hidden"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="max-w-6xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}`}>
            <h2 
              className="text-2xl lg:text-3xl font-light mb-8"
              style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#333333' }}
            >
              创始人的初心
            </h2>
            <div className="w-32 h-px mb-12" style={{ background: 'linear-gradient(to right, transparent, #ED5736, transparent)' }}></div>
            
            <div className="space-y-8">
              <p 
                className="text-sm lg:text-lg leading-relaxed font-light"
                style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#666666' }}
              >
                "在一次偶然的机会中，我接触到了一本珍贵的宫廷古籍，记载着慈禧太后的养颜秘方。那一刻，我深深被这些千年智慧所震撼。"
              </p>
              <p 
                className="text-sm lg:text-lg leading-relaxed font-light"
                style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#666666' }}
              >
                "现代女性面临着前所未有的生活压力，内分泌失调、肌肤问题层出不穷。我意识到，古人'内调外养'的智慧正是现代人最需要的。"
              </p>
              <p 
                className="text-sm lg:text-lg leading-relaxed font-light"
                style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#666666' }}
              >
                "于是，宫廷养森诞生了。我们不仅要传承这些珍贵的古方，更要用现代科学验证其安全性和有效性，让每一位女性都能享受到宫廷级的养护体验。"
              </p>
            </div>

            <div className="mt-12 flex items-center">
              <div className="w-16 h-px mr-4" style={{ backgroundColor: '#ED5736' }}></div>
              <span 
                className="text-xs lg:text-sm font-light"
                style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#999999' }}
              >
                宫廷养森创始人
              </span>
            </div>
          </div>

          {/* Right Image */}
          <div className={`transform transition-all duration-1000 delay-300 ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-8 opacity-0'}`}>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/1a74cb3037579a16b64f783fdc2de94d.jpeg"
                alt="创始人"
                className="w-full h-auto object-cover rounded-lg shadow-2xl"
              />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-full opacity-20" style={{ backgroundColor: '#ED5736' }}></div>
              <div className="absolute -top-4 -left-4 w-16 h-16 rounded-full opacity-10" style={{ backgroundColor: '#6B7F8F' }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStory;
